export enum Actions {
  CHANGE_LOCALE = 'CHANGE_LOCALE'
}

export const DEFAULT_LOCALE: string = 'en';
export const LOCALE_SETTING = 'WEB_LOCALE';
